import axios from "axios";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Select, { components } from "react-select";
import { toast } from "react-toastify";
import ReactTooltip from "react-tooltip";
import "../assets/scss/global.scss";
import trackingEventDictionary from "../core/dictionary/tracking-event";
import { generateTrackingObject } from "../core/global/global-country-functions";
import { trademoTrackingEvents } from "../core/global/trademo-tracking";
import { getApiUrl } from "../utils/baseUrl";
import commaFormat from "@utils/commaFormat";

const searchTypeCustomStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 54,
    backgroundColor: "#fcfcfd",
    borderRadius: "4px",
    fontSize: "14px",
    fontWeight: 600,
    border: state.isFocused ? "1px solid #6f08f1 !important" : "solid 1px #d0d5dd !important",
    boxShadow: state.isFocused ? "0 0 0 2px #e4dbfa !important" : "none !important",
  }),
  menu: (base) => ({
    ...base,
    fontSize: "14px",
    fontWeight: 600,
    padding: "8px",
  }),
  option: (base, { isDisabled, isFocused, isSelected }) => ({
    ...base,
    backgroundColor: isDisabled ? null : isSelected ? "transparent" : isFocused ? "transparent" : null,
    color: isDisabled ? null : isSelected ? "#1a1722" : isFocused ? "#1a1722" : null,
    cursor: "pointer !important",
    marginBottom: "8px",
  }),
};

const apiEndpoint = {
  contactRequestDropdown: getApiUrl("CompanyContactDetails/contactApolloDropdown"),
  submitContactsRequest: getApiUrl("CompanyContactDetails/submitContactsRequest"),
};
const requestContactType = {
  phoneAndEmail: "phoneAndEmail",
  phone: "phone",
  email: "email",
};
const SearchContactForm = (props) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [dropDownOptions, setDropDownOptions] = useState({ department: [], seniority: [], location: [] });
  const [selectedValues, setSelectedValues] = useState({ ...props.selectedValues });
  const [contactType, setContactType] = useState(requestContactType.phone);
  const [maxContactCount, setMaxContactCount] = useState(1);
  const [description, setDescription] = useState("");
  const [jobTitle, setJobTitle] = useState(props?.title ? props.title : (props?.selectedValues?.job_title[0] ?? ""));

  const closeConfirmModal = () => {
    setShowConfirmModal(false);
    props.closeModal();
  };

  const getContactsDropdown = () => {
    let tempOptions = { ...dropDownOptions };
    axios.get(apiEndpoint.contactRequestDropdown).then((res) => {
      if (res && res.data && res.data.message && res.data.message !== "") {
        if (res.data.message.department && res.data.message.department !== "") {
          for (let i = 0; i < res.data.message.department.length; i++) {
            tempOptions[props.dropdownFields.department].push(res.data.message.department[i]);
          }
        }
        if (res.data.message.seniority && res.data.message.seniority !== "") {
          for (let i = 0; i < res.data.message.seniority.length; i++) {
            tempOptions[props.dropdownFields.seniority].push(res.data.message.seniority[i]);
          }
        }
        if (res.data.message.location && res.data.message.location !== "") {
          for (let i = 0; i < res.data.message.location.length; i++) {
            tempOptions[props.dropdownFields.location].push({ label: res.data.message.location[i], value: res.data.message.location[i] });
          }
        }

        setDropDownOptions({ ...tempOptions });
      }
    });
  };
  const bindSelectedValues = function (e, type) {
    if (type === "typeOfContact") {
      setContactType(e);
      return;
    }
    if (type === "description") {
      setDescription(e);
      return;
    }
    if (type === "title") {
      setJobTitle(e);
      return;
    }
    let tempValues = { ...selectedValues };
    if (e && e.length > 0 && e.length <= 5) {
      tempValues[type] = e;
    } else if (!e || e.length === 0) {
      tempValues[type] = [];
    }
    setSelectedValues({ ...tempValues });
  };
  const handleSubmit = function (e) {
    e.stopPropagation();
    if (props && props.userCreditsCount && typeof props.userCreditsCount === "number" && props.userCreditsCount < 0) {
      toast.error("You do not have enough credits.");
      return;
    }
    let flag = false;
    for (const value of Object.values(selectedValues)) {
      if (value && Array.isArray(value) && value.length) {
        flag = true;
        break;
      }
    }
    if (flag === false && jobTitle !== "") {
      flag = true;
    }
    if (!flag) {
      toast.error("Please select any one option.");
      return;
    }
    if (!maxContactCount || maxContactCount < 1) {
      setMaxContactCount(1);
    }
    let requestObject = {};
    requestObject.slug = !!props.data.data.companyData.name && props.data.data.companyData.name !== "" ? props.data.data.companyData.name : "";
    requestObject.companyId = !!props.data.data.companyData.id && props.data.data.companyData.id !== "" ? props.data.data.companyData.id : "";
    requestObject.companyName = !!props.data.data.companyData.name && props.data.data.companyData.name !== "" ? props.data.data.companyData.name : "";
    requestObject.planId = localStorage?.userCurrentPlan ? JSON.parse(localStorage.userCurrentPlan)?.user_active_plan || "" : "";
    requestObject.seniority = selectedValues.seniority.map((element) => element.value);
    requestObject.department = selectedValues.department.map((element) => element.value);
    requestObject.location = selectedValues.location.map((element) => element.value);
    requestObject.jobFunction = "";
    requestObject.jobTitle = jobTitle;
    requestObject.maxRequestedContacts = +maxContactCount < 1 ? 1 : +maxContactCount;
    requestObject.hasRequestedPhone = contactType === requestContactType.phone || contactType === requestContactType.phoneAndEmail ? "True" : "False";
    requestObject.hasRequestedEmail = contactType === requestContactType.email || contactType === requestContactType.phoneAndEmail ? "True" : "False";
    requestObject.description = description;
    requestObject.status = "Open";
    setTimeout(() => {
      onConfirm(requestObject);
    }, 100);
    return;
  };
  useEffect(() => {
    getContactsDropdown();
    setSelectedValues({ ...props.selectedValues });
  }, []);
  const onConfirm = (requestObject) => {
    trademoTrackingEvents(trackingEventDictionary.companyProfilePageSearchContactsTabRequestContacts, generateTrackingObject(props.dataSource, props.pathName, props.currentUserPlan));
    if (requestObject && requestObject !== "") {
      axios.post(apiEndpoint.submitContactsRequest, { ...requestObject }).then((res) => {
        setShowConfirmModal(false);
        props.closeModal();
        if (res.data && res.data.status && res.data.status.toLowerCase() === "success") {
          toast.success(res.data.message);
        } else {
          toast.error(res.data.message);
        }
      });
    }
  };

  const ParentOption = (props) => {
    return (
      <div>
        <components.Option {...props}>
          <div className="d-flex align-items-center">
            {/* className='form-check-input company-contact-select' */}
            <input className={props.selectProps.value.length < 5 ? "form-check-input company-contact-select" : props.isSelected ? "form-check-input company-contact-select" : "form-check-input company-contact-select custom-checkbox-unselect"} type="checkbox" checked={props.isSelected} readOnly />
            <label data-tip={props.selectProps.value.length < 5 ? "" : props.isSelected ? "" : "You can select maximum of 5 values."} data-for={"propslabel"} className="text-break m-0 mx-2 pl-1 pt-2 checboxselectlabel">
              {props.label}
            </label>
            {props.selectProps.value.length < 5 ? "" : props.isSelected ? "" : <ReactTooltip className="trademo-tooltip text-capitalize" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="bottom" multiline={true} id={"propslabel"} />}
          </div>
        </components.Option>
      </div>
    );
  };

  const parentCustomComponents = { Option: ParentOption };

  return (
    <>
      <Modal backdrop="static" size="lg" centered show={props.showRequestModal} onHide={() => props.closeModal()} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title className="w-100 d-flex align-items-center justify-content-between">
            <span>Confirmation</span>
            {!!props.remainingValueAddCount && (
              <span className="credits-strip">
                <img src="https://res.cloudinary.com/ddfycftwg/image/upload/v1641874517/images/icons/Iconly_Bold_Info_Circle_bwgt7p.svg" alt="info icon" />
                <span>Remaining Value Add Credit(s): {commaFormat(props.remainingValueAddCount)}</span>
              </span>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {props.showRequestModal ? (
            <>
              <div className="d-flex align-items-center  justify-content-center w-100 text-align-center">
                <div className="container fetch-access-heading text-center">It seems the search criteria did not match the contacts in our database. Our team could try to dig deeper into your requirements and get you more relevant results over the next 24 business hours.</div>
              </div>
              <div className="mt-3">
                <label className="contact-label">Enter Job Title</label>
                <input value={jobTitle} onChange={(e) => bindSelectedValues(e.target.value, "title")} placeholder="Enter Job title of the contacts" className="contact-input-field d-block" />
              </div>
              <div className="mt-3">
                <label className="contact-label">Select Department of the contacts</label>
                <span>
                  <Select options={dropDownOptions[props.dropdownFields.department]} styles={searchTypeCustomStyles} placeholder="You can select upto 5 options" isMulti closeMenuOnSelect={false} value={selectedValues.department} hideSelectedOptions={false} components={parentCustomComponents} onChange={(e) => bindSelectedValues(e, props.dropdownFields.department)} />
                </span>
              </div>
              <div className="mt-3">
                <label className="contact-label">Select Management level of the contacts</label>
                <span>
                  <Select options={dropDownOptions[props.dropdownFields.seniority]} styles={searchTypeCustomStyles} placeholder="You can select upto 5 options" isMulti value={selectedValues.seniority} closeMenuOnSelect={false} hideSelectedOptions={false} components={parentCustomComponents} onChange={(e) => bindSelectedValues(e, props.dropdownFields.seniority)} />
                </span>
              </div>
              <div className="mt-3">
                <label className="contact-label">Select the Country of the contacts</label>
                <span>
                  <Select options={dropDownOptions[props.dropdownFields.location]} styles={searchTypeCustomStyles} placeholder="You can select upto 5 options" isMulti value={selectedValues.location} closeMenuOnSelect={false} hideSelectedOptions={false} components={parentCustomComponents} onChange={(e) => bindSelectedValues(e, props.dropdownFields.location)} />
                </span>
              </div>
              <div className="mt-3">
                <label className="contact-label">Maximum number of contacts that you are interested in</label>
                <span
                  className="d-block"
                  onClick={(e) => {
                    e.stopPropagation();
                  }}>
                  <button
                    className="max-contact-button ml-0"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setMaxContactCount(maxContactCount - 1 < 1 ? 1 : maxContactCount - 1);
                    }}>
                    -
                  </button>
                  <input
                    className="max-contact-input text-center"
                    type="number"
                    readOnly
                    value={maxContactCount}
                    onChange={(e) => {
                      if (e.target.value > 5) {
                        setMaxContactCount(5);
                      } else {
                        setMaxContactCount(+e.target.value);
                      }
                    }}
                  />
                  <button
                    className="max-contact-button ml-0"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setMaxContactCount(maxContactCount + 1 > 5 ? 5 : maxContactCount + 1);
                    }}>
                    +
                  </button>
                </span>
              </div>
              <div className="mt-3">
                <label className="contact-label">Type of contact</label>
                <div className="row justify-content-between gx-1 p-0 m-0" onChange={(e) => bindSelectedValues(e.target.value, "typeOfContact")}>
                  <div className={`col-4 ${contactType === requestContactType.phone ? "custom-card-fetch-active" : "custom-card-fetch"}`}>
                    <div className="form-check">
                      <input className="form-check-input" type="radio" readOnly name="flexRadioDefault1" checked={contactType === requestContactType.phone} id="phone" value={requestContactType.phone} />
                      <label className="form-check-label" htmlFor="phone">
                        Phone Number
                      </label>
                    </div>
                  </div>
                  <div className={`col-4 ${contactType === requestContactType.phoneAndEmail ? "custom-card-fetch-active" : "custom-card-fetch"}`}>
                    <div className="form-check ">
                      <input className="form-check-input" type="radio" readOnly name="flexRadioDefault1" checked={contactType === requestContactType.phoneAndEmail} id="emailAndPhone" value={requestContactType.phoneAndEmail} />
                      <label className="form-check-label" htmlFor="emailAndPhone">
                        Phone number and Email
                      </label>
                    </div>
                  </div>
                  <div className={`col-4 ${contactType === requestContactType.email ? "custom-card-fetch-active" : "custom-card-fetch"}`}>
                    <div className="form-check ">
                      <input className="form-check-input" type="radio" readOnly checked={contactType === requestContactType.email} name="flexRadioDefault1" id="email" value={requestContactType.email} />
                      <label className="form-check-label" htmlFor="email">
                        Email
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-3">
                <label className="contact-label">Any message or description you want to add</label>
                <div>
                  <textarea className="contact-form-text-area" onChange={(e) => bindSelectedValues(e.target.value, "description")} rows={4} maxLength="280" />
                </div>
              </div>
            </>
          ) : (
            <></>
          )}
          <Modal backdrop="static" className="confirm-popover" centered show={showConfirmModal} onHide={closeConfirmModal} animation={false}>
            <Modal.Header closeButton>
              <Modal.Title>Confirmation</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="row m-0 ">
                <span>
                  {" "}
                  If <b> {maxContactCount} </b> contacts are found as per your request, <b> {maxContactCount * 3} </b> credits would be deducted.
                </span>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <div className="col-4 p-0 m-0 d-flex justify-content-end">
                <button type="button" className="btn btn-outline-secondary trademo-outline-btn btn-sm mr-2" onClick={() => closeConfirmModal()}>
                  Cancel
                </button>
                <button type="button" className="btn btn-primary btn-sm trademo-new-btn" onClick={() => onConfirm()}>
                  Confirm
                </button>
              </div>
            </Modal.Footer>
          </Modal>
        </Modal.Body>
        <Modal.Footer>
          <div className="w-100 d-flex justify-content-between">
            <label className="m-0 invisible">
              <i>*3 credits would be deducted for every contact fetched.</i>
            </label>
            <div>
              <button type="button" className="btn btn-outline-secondary trademo-outline-btn btn-sm mr-2" onClick={() => props.closeModal()}>
                Cancel
              </button>
              <button type="button" className="btn btn-primary btn-sm trademo-new-btn" onClick={(e) => handleSubmit(e)}>
                Request Contact
              </button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default SearchContactForm;
